const specialChars = {
  ą: 'a',
  č: 'c',
  ę: 'e',
  ė: 'e',
  į: 'i',
  š: 's',
  ų: 'u',
  ū: 'u',
  ž: 'z',
  // pl extras
  ć: 'c',
  ł: 'l',
  ń: 'n',
  ó: 'o',
  ś: 's',
  ź: 'z',
  ż: 'z',
};

function allReplace(str: string, obj: any) {
  let retStr = str;
  for (const x in obj) {
    retStr = retStr.replace(new RegExp(x, 'g'), obj[x]);
  }
  return retStr;
}

function prepare(str: string): string {
  return allReplace(
    str
      .toLowerCase()
      .replace(/\s/g, '')
      .replace(/:|\.|,|;/g, ''),
    specialChars
  );
}

export function simpleSearch(haystack: string, needle: string): boolean {
  haystack = prepare(haystack);
  needle = prepare(needle);
  return haystack.includes(needle);
}
